import { EMPTY_ADDRESS, getEmptyShift } from '@vyce/core/src/modules/timeModule/constants';
import { TrackingType } from '@vyce/core/src/types';

export const SHIFTS_FIELD = 'shifts' as const;

/**
 * Names of the steps that make up one shift. They repeat once per shift, so in the steps
 * array they are suffixed with the shift index (see `buildShiftStepName`).
 */
export const SHIFT_STEP = {
  shift: 'ShiftStep',
  regularRate: 'DefaultRegularRateStep',
  regularSchedule: 'RegularScheduleStep',
  overtime: 'OvertimeScheduleStep',
  overtimeRate: 'DefaultOvertimeRateStep',
  overtimeSchedule: 'OvertimeScheduleHoursStep',
  breaks: 'BreaksStep',
  addAnother: 'AddAnotherShiftStep',
};

export const defaultValues = {
  name: '',
  address: EMPTY_ADDRESS,
  payScheduleId: '',
  teamMembersCount: 0,
  shifts: [getEmptyShift()],
  approver: '',
  polygon: null,
  tracking_type: { value: TrackingType.BREADCRUMBS, name: 'Breadcrumbs' },
};
